import { ca } from '@cian/analytics';

import { getAllProducs } from '../../utils/trackings';
import { IFavoriteEntity } from '../../types/results';

export function trackCheckboxAllClick(favoriteEntities: IFavoriteEntity[]) {
  const products = getAllProducs({ favoriteEntities });

  ca('eventSite', {
    name: 'oldevent',
    category: 'ListingFavorites',
    action: 'Click',
    label: 'ChooseAllOffersCheckbox',
    products,
  });
}
